import React, { useEffect, useState } from 'react';
import { Col, Input, Row, Form, Select, TimePicker } from 'antd';
// import { ReactComponent as SaveIcon } from '../../../assets/save-icon.svg';
// import { ReactComponent as EditIcon } from '../../../assets/edit-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  createClassSession,
  // setClassSessionDetailsIsEdit,
  updateClassSession,
} from '../redux/actions';
// import SpinnerComponent from '../../../components/spinner';
// import { isValidNumber } from '../../../globalUtils/axiosConfig';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import Player from './audio';
import { baseURL } from '../../../globalUtils/axiosConfig';
// import { fetchUserDetailsUtils } from '../../UserManager/redux/actions';

const SlotDetailsSection = ({
  isClassSessionUpdate,
  canUpdate,
  rooms,
  assessorOptions,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentClassSession, setCurrentClassSession] = useState({
    start_time: null,
    end_time: null,
    session_status: '',
    created_by: null,
  });
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Option } = Select;

  const {
    createClassSessionLoading,
    currentClassSessionObj,
    classSessionDetailsIsEdit,
  } = useSelector((state) => state.classSessionsReducer);

  useEffect(() => {
    if (currentClassSessionObj?._id) {
      setCurrentClassSession(currentClassSessionObj);
      //       session_status
      // start_time
      // end_time
      // created_by
      // teacher_recording_path
      const { start_time, end_time, ...res } = currentClassSessionObj;
      form.setFieldsValue({
        ...res,
        start_time: start_time ? moment(start_time) : null,
        end_time: end_time ? moment(end_time) : null,
      });
    }
  }, [currentClassSessionObj]);

  useEffect(() => {
    setLoading(createClassSessionLoading);
  }, [createClassSessionLoading]);

  useEffect(() => {
    if (
      pathname.includes('create') &&
      currentClassSessionObj?._id === undefined
    ) {
      setIsEdit(true);
    } else {
      setIsEdit(classSessionDetailsIsEdit);
    }
  }, [classSessionDetailsIsEdit, currentClassSessionObj]);

  const onFinish = (values) => {
    const { ...res } = values;

    let { slot_date, start_time, end_time } = values;
    slot_date = slot_date.format('YYYY-MM-DD');
    let updatedSlotDate = moment(`${slot_date} 00:00`);
    start_time = moment(`${slot_date} ${start_time.format('HH:mm')}`);
    end_time = moment(`${slot_date} ${end_time.format('HH:mm')}`);

    if (!res.room) {
      delete res.room;
    }
    isClassSessionUpdate
      ? dispatch(
          updateClassSession({
            ...res,
            slot_id: currentClassSessionObj._id,
            slot_date: updatedSlotDate,
            start_time,
            end_time,
          })
        )
      : dispatch(
          createClassSession({
            ...res,
            slot_date: updatedSlotDate,
            start_time,
            end_time,
          })
        );
  };
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const handleSave = () => {
    form.submit();
  };

  // const capitalizeFirstLetter = (str) =>
  //   str && str.charAt(0).toUpperCase() + str.slice(1);

  const startTime = Form.useWatch('start_time', form);

  const SelectFormItem = (props) => {
    const { label, name, required, options, placeholder } = props;
    return (
      <Form.Item
        label={label}
        name={name}
        rules={[
          {
            required: required,
            message: 'Required!',
          },
        ]}
      >
        <Select
          size='middle'
          style={{
            width: '100%',
          }}
          disabled={!isEdit}
          placeholder={placeholder}
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          showSearch
          optionFilterProp='children'
          optionLabelProp='label'
        >
          {options.map(({ label, value }) => {
            return (
              <Option key={value} value={value} label={label}>
                {label}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  };

  let disabledHoursList = [0, 1, 2, 3, 4, 5, 6, 20, 21, 22, 23];

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24} className='heading-col'>
          <Row align='middle' justify='space-between'>
            <Col>
              <div>
                <span className='heading-span'>Class Session Details</span>
              </div>
            </Col>
            <Col>
              {/* {isEdit ? (
                loading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill='#e21c21'
                    height={16}
                    onClick={() => dispatch(setClassSessionDetailsIsEdit(true))}
                  />
                )
              )} */}
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          className={`user-details-section project-details-section ${
            !isEdit && 'is-edit'
          }`}
          style={{ minHeight: '25vh' }}
        >
          <Row justify='center'>
            <Col span={23}>
              <Form
                {...formItemLayout}
                form={form}
                name='user-details'
                // onFinish={onFinish}
                initialValues={currentClassSession}
                scrollToFirstError
                labelWrap={true}
                layout='horizontal'
                className='user-detail-form'
                requiredMark={false}
              >
                <Row gutter={[20, 10]}>
                  <Col md={6} lg={6} xl={6} xxl={6}>
                    <SelectFormItem
                      label='Created By'
                      name='created_by'
                      required={true}
                      options={assessorOptions}
                      // placeholder='Select created By'
                    />
                  </Col>
                  <Col md={6} lg={6} xl={6} xxl={6}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='start_time'
                      label='Start Time'
                    >
                      <TimePicker
                        use12Hours
                        width='100%'
                        format='DD MMM YYYY hh:mm A'
                        disabled={!isEdit || !canUpdate}
                        suffixIcon={null}
                        placeholder='Start time'
                        disabledTime={() => ({
                          disabledHours: () => {
                            return disabledHoursList;
                          },
                        })}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={6} lg={6} xl={6} xxl={6}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                        {
                          validator: (rule, value) => {
                            if (value && value <= startTime) {
                              return Promise.reject(
                                'End time should be greater than start time!'
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      name='end_time'
                      label='End Time'
                    >
                      <TimePicker
                        use12Hours
                        width='100%'
                        format='DD MMM YYYY hh:mm A'
                        suffixIcon={null}
                        disabled={!isEdit || !canUpdate}
                        placeholder='End time'
                        disabledTime={() => ({
                          disabledHours: () => {
                            return disabledHoursList;
                          },
                        })}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={6} lg={6} xl={6} xxl={6}>
                    <SelectFormItem
                      label='Status'
                      name='session_status'
                      required={true}
                      options={[
                        { key: 'Completed', value: 'Completed' },
                        { key: 'In Progress', value: 'Inprogress' },
                      ]}
                      // placeholder='Select status'
                    />
                  </Col>
                  <Col md={24} lg={24} xl={24} xxl={24}>
                    <Form.Item label='Recording'>
                      {currentClassSessionObj?.teacher_recording_path ? (
                        <Player
                          url={`${baseURL}/${currentClassSessionObj.teacher_recording_path}`}
                        />
                      ) : (
                        <Input disabled value={'Not Available'} />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className='empty-div'></div>
    </>
  );
};

export default SlotDetailsSection;
